export const SET_SHOWING_BOOLEAN = 'SET_SHOWING_BOOLEAN';
